module.exports = __webpack_public_path__ + "static/media/tequan1.5bcadbd0.png";